import React from "react";
import Navbar  from "../components/Navbar/Navbar";
const ShippingPolicy = () => {
    return (
        <div>
            <Navbar />
            <div  style={{padding:60}}>
     
            <h1>
                • Shipping Policy for Peer-to-Peer Book Lending: <br /><br />
            </h1>
            At Freshpage, we facilitate peer-to-peer book lending, where
            borrowers may become lenders at the end of the lending period. To
            ensure a smooth and convenient experience, we have developed a
            comprehensive shipping policy that covers the lending process,
            including additional services for delivery and pickup:<br /><br />

            <h3> • Borrower Responsibility:</h3><br /><br />
            • Borrowers who become lenders are responsible for delivering the
            book to the next borrower in a timely manner, within [X] business
            days of the lending period ending.
            .<br /><br />
            • Borrowers must package the book securely to prevent damage
            during transit, using appropriate packaging materials.
            .<br /><br />
            • Borrowers must provide accurate delivery information, including the
            recipient's complete and correct address, to ensure successful book
            delivery.
            .<br /><br />
            <h3> • Delivery Services:
            </h3><br /><br />
            • Freshpage offers additional delivery services for borrowers and
            lenders who prefer a convenient shipping option.<br /><br />
            • Borrowers and lenders can opt to use our partnered delivery
            services for a fee. Freshpage will arrange pickup and delivery based
            on the provided addresses.<br /><br />
            • The shipping cost for these additional services will be shared
            between the borrower and lender, with Freshpage retaining a
            portion of the fee for facilitating the service.<br /><br />
            <h3>• Tracking and Confirmation:</h3>
            <br /><br />
            • Both borrowers and lenders are encouraged to use shipping
            methods that provide tracking and delivery confirmation.<br /><br />
            • Borrowers must share the tracking information with the next
            borrower, allowing them to monitor the shipment's progress.
            <br /><br />
            <h3> • Book Return:</h3><br /><br />
            • Borrowers must return the book to the lender within the agreedupon timeframe, using a shipping method that includes tracking and
            delivery confirmation.<br /><br />
            • If borrowers and lenders choose the additional delivery service
            provided by Freshpage, Freshpage will arrange pickup and return.<br /><br />
            <h3>• Book Condition and Damage:
            </h3><br /><br />
            • Borrowers must take care to return the book in the same condition
            as received, considering fair wear and tear.<br /><br />
            • In the event of significant damage or loss during shipping, the
            lender assumes responsibility and may be held liable for covering
            the cost of the book loss, investing in a replacement copy, and
            covering associated processing charges.<br /><br />
            • Please note that Freshpage facilitates the lending process and offers
            additional delivery services for convenience. We encourage
            borrowers and lenders to communicate openly regarding shipping
            preferences and expectations.<br /><br />
            • By following this shipping policy, we aim to ensure a reliable and
            efficient peer-to-peer book lending experience, empowering
            members to share books and enjoy reading while providing
            convenient delivery options.<br /><br />
        </div>
        
        </div>
    );
};

export default ShippingPolicy;